import { UNPROCESSABLE_ENTITY } from 'constants/statusCodes';

import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * The reason the datasource route gave for rows it cannot make again, or null for any other error.
 *
 * The route answers 422 when the rows were dropped and the stored statement no longer runs. That
 * is not a failure of the read but a fact about the datasource, told to the reader in place of the
 * rows; the display keeps its place in the chat. A 422 is final and is never asked again.
 */
const readDatasourceDroppedReason = (error: FetchBaseQueryError | SerializedError | undefined): string | null => {
  if (!error || !('status' in error) || error.status !== UNPROCESSABLE_ENTITY) {
    return null;
  }

  const message = typeof error.data === 'object' && error.data && 'message' in error.data
    ? (error.data as { message?: unknown }).message
    : undefined;

  return typeof message === 'string' && message ? message : '';
};

export default readDatasourceDroppedReason;
